module.exports = __webpack_public_path__ + "img/topLogo.9e6da14d.png";